<template>
  <Icon :icon="iconName" :width="size" :height="size" :style="{ color: brandColor }" />
</template>

<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { computed } from 'vue'

interface Props {
  platform: string
  size?: number
  color?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: 'currentColor',
})

const iconName = computed(() => {
  const iconMap: Record<string, string> = {
    facebook: 'simple-icons:facebook',
    google: 'simple-icons:google',
    microsoft: 'simple-icons:microsoft',
    tiktok: 'simple-icons:tiktok',
    pinterest: 'simple-icons:pinterest',
    snapchat: 'simple-icons:snapchat',
  }

  return iconMap[props.platform] || 'simple-icons:question-mark'
})

const brandColor = computed(() => {
  const colorMap: Record<string, string> = {
    facebook: '#1877F2',
    google: '#4285F4',
    microsoft: '#00BCF2',
    tiktok: '#000000',
    pinterest: '#E60023',
    snapchat: '#FFFC00',
  }

  return colorMap[props.platform] || props.color
})
</script>
